"use client";

import { Icon } from "@/components/ui/Icon";
import { Button } from "@/components/ui/primitives";
import { useShell } from "@/components/shell/ShellContext";

export function SignedOut({ title, body }: { title: string; body: string }) {
  const { openSignIn } = useShell();

  return (
    <div className="flex flex-col items-center gap-[12px] px-[24px] py-[64px] text-center">
      <span className="grid h-[38px] w-[38px] place-items-center rounded-full border border-border bg-elevation-2 text-fg">
        <Icon name="user" size={20} />
      </span>

      <div className="flex max-w-[46ch] flex-col gap-[4px]">
        <p className="text-[12px] font-bold leading-[1.6] text-fg">{title}</p>
        <p className="text-[12px] leading-[1.6] text-fg-subtle">{body}</p>
      </div>

      <Button size="md" icon="user" onClick={() => openSignIn()}>
        Sign in
      </Button>
    </div>
  );
}
